import React from "react";
import parse from "autosuggest-highlight/parse";
import match from "autosuggest-highlight/match";

const handleRenderOption = (option, { inputValue }) => {
  const matches = match(`${option.UserName} - ${option.Nombres}  ${option.ApellidoPaterno}  ${option.ApellidoMaterno}`, inputValue);
  const parts = parse(`${option.UserName} - ${option.Nombres}  ${option.ApellidoPaterno}  ${option.ApellidoMaterno}`, matches);
  const highlightStyle = {
    fontWeight: 700,
    backgroundColor: "lightyellow",
    padding: "5px 2px",
  };
  return (
    <div>
      {parts.map((part, index) => (
        <span key={index} style={part.highlight ? highlightStyle : {}}>
          {part.text}
        </span>
      ))}
    </div>
  );
};

export default handleRenderOption;
